// components/Modal.jsx
import React, { useEffect } from 'react';
import './Modal.css';

const Modal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    message, 
    type = 'info', // 'info', 'confirm', 'success', 'error'
    confirmText = 'Подтвердить',
    cancelText = 'Отмена'
}) => {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                <div className={`modal-header ${type}`}>
                    <h3>{title}</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                
                <div className="modal-body">
                    <p>{message}</p>
                </div>
                
                <div className="modal-footer">
                    {type === 'confirm' ? (
                        <>
                            <button className="modal-btn cancel" onClick={onClose}>
                                {cancelText}
                            </button>
                            <button className="modal-btn confirm" onClick={onConfirm}>
                                {confirmText}
                            </button>
                        </>
                    ) : (
                        <button className="modal-btn ok" onClick={onClose}>
                            OK
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Modal;